<template>
  <div ref="wrapRef" class="col-filter-wrap" @click.stop>
    <a
      role="button"
      class="col-filter-icon"
      :class="{ active: !!value }"
      @click.stop="$emit('toggle')"
    >
      <b-icon icon="search" :scale="0.75"></b-icon>
    </a>
    <div v-if="isOpen" class="col-filter-menu" :style="menuStyle" @click.stop>
      <form class="p-2" @submit.prevent="submit">
        <BaseInput v-model="input" :placeholder="placeholder" size="sm" />
        <div class="d-flex align-items-center mt-2" style="gap: 6px;">
          <b-button variant="primary" size="sm" type="submit">Apply</b-button>
          <b-button
            v-if="value"
            type="button"
            variant="outline-secondary"
            size="sm"
            @click.stop="$emit('clear')"
          >Clear</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed, watch } from '@vue/composition-api'

import { BaseInput } from '@components/base'

export default defineComponent({
  name: 'BDXPendingColumnFilter',
  components: { BaseInput },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Search...'
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle', 'apply', 'clear'],
  setup(props, { emit }) {
    const input = ref('')
    const wrapRef = ref(null)
    const menuPos = ref({ top: 0, left: 0, right: null })

    watch(() => props.isOpen, (open) => {
      if (open && wrapRef.value) {
        const rect = wrapRef.value.getBoundingClientRect()
        const dropdownWidth = 220
        const fitsRight = rect.left + dropdownWidth <= window.innerWidth
        menuPos.value = {
          top: rect.bottom + 6,
          left: fitsRight ? rect.left : null,
          right: fitsRight ? null : window.innerWidth - rect.right
        }
      }
    })

    const menuStyle = computed(() => ({
      position: 'fixed',
      top: menuPos.value.top + 'px',
      left: menuPos.value.left != null ? menuPos.value.left + 'px' : 'auto',
      right: menuPos.value.right != null ? menuPos.value.right + 'px' : 'auto'
    }))

    const submit = () => {
      emit('apply', input.value)
      input.value = ''
    }

    return { input, wrapRef, menuStyle, submit }
  }
})
</script>

<style scoped>
.col-filter-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.col-filter-icon {
  display: flex;
  align-items: center;
  opacity: 0.4;
  cursor: pointer;
  color: inherit;
}

.col-filter-icon:hover,
.col-filter-icon.active {
  opacity: 1;
  color: var(--primary);
}

.col-filter-menu {
  z-index: 9999;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 220px;
}
</style>
